import { styled } from '@mui/material/styles';
import { BACKGROUND } from '../../shared/Helpers/colors';

export const Background = styled('div')(() => ({
	width: '100%',
	height: '100vh',
	backgroundColor: BACKGROUND.BASE[100],
}));

export const ContentWrapper = styled('div')(() => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	width: '100%',
	height: '100vh',
}));
